import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

// Based on
//- https://stackoverflow.com/questions/77022052/react-router-6-15-scroll-restoration-while-using-createroutesfromelements
//- https://stackoverflow.com/questions/34727664/how-to-scrollto-without-animation

export default function ScrollToTopLayout() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, [pathname]);

    return <Outlet />;
}
